<template>
    <div>
      <input v-model="payment.total" placeholder="Total" />
      <input v-model="payment.currency" placeholder="Currency" />
      <input v-model="payment.method" placeholder="Method" />
      <button @click="processPayment">Pagar con PayPal</button>
    </div>
  </template>
  
  <script>
  import api from "@/services/api";
  
  export default {
    data() {
      return {
        payment: {
          total: '',
          currency: 'USD',
          method: 'paypal',
          intent: 'sale',
          description: 'Descripción del pago'
        }
      };
    },
    methods: {
      processPayment() {
        api.post('/paypal/pay', this.payment)
          .then(response => {
            // La respuesta debe incluir la URL de redirección de PayPal
            window.location.href = response.data;
          })
          .catch(error => {
            console.error('Error al procesar el pago:', error);
          });
      }
    }
  }
  </script>  